export const formatPhoneNumber = (number: string) => {
  if (!number) return "";

  const numericNumber = number.replace(/\D/g, "");

  const areaCode = numericNumber.slice(0, 3);
  const firstPart = numericNumber.slice(3, 6);
  const secondPart = numericNumber.slice(6, 10);

  return `(${areaCode}) ${firstPart}-${secondPart}`;
};
